import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';
import { canAccessRoute as checkRoute, isSubscriptionPending } from '../utils/routeAccess';
import { usePermissions } from './usePermissions';
import { useSubscriptionAccess } from './useSubscriptionAccess';

export function useRouteAccess() {
  const { user } = useAuth();
  const { tenant } = useTenant();
  const { permissions } = usePermissions();
  const { moduleSet, loading } = useSubscriptionAccess();
  const subscriptionReady = !loading;

  const canAccessRoute = useCallback(
    (path) =>
      checkRoute(path, {
        permissions,
        tenant,
        user,
        moduleSet,
        subscriptionReady,
      }),
    [permissions, tenant, user, moduleSet, subscriptionReady]
  );

  const isRoutePending = useCallback(
    (path) => isSubscriptionPending(path, subscriptionReady),
    [subscriptionReady]
  );

  return { canAccessRoute, isRoutePending, subscriptionReady };
}
